import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

export const useI18n = () => {
  const { t, i18n } = useTranslation();

  const translate = useCallback((key, options = {}) => {
    return t(key, options);
  }, [t]);

  const changeLanguage = useCallback((lang) => {
    return i18n.changeLanguage(lang);
  }, [i18n]);

  const getCurrentLanguage = useCallback(() => {
    return i18n.language;
  }, [i18n]);

  // 不需要翻译的文本（保持英文）
  const noTranslate = useCallback((text) => {
    return text;
  }, []);

  return {
    t: translate,
    changeLanguage,
    getCurrentLanguage,
    noTranslate
  };
}; 